import { storeLogger } from 'ngrx-store-logger';
// Create reducer for logging
export function getLogger() {
    function logger(reducer) {
        return storeLogger({ collapsed: true })(reducer);
    }
    // Only use the logger in the dev environment
    return process.env.YC_CODE_ENV === 'development' ? [logger] : [];
}
